/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */

import {
  HeroStacked,
  BackLinkSection,
  CallOut,
  SideXSide,
  TextSection,
  Feature,
  VideoComponent,
  Divider,
  Hero
} from 'aether-marketing';
import TextImageSideXSide from './Shared/sota-vertical/TextImageSideXSide';
import hero from './Shared/heroes/Hero';
import metricTwo from './Shared/metricTwo';
import amplitude from './Shared/amplitude';
import amplitudeExample from './Shared/amplitudeExample';
import footer from './Shared/footer';
import heroCentered from './Shared/heroes/heroCentered';
import downloadsHero from './Shared/downloads/downloadsHero';
import slider from './Shared/slider';
import leftTitleWithText from './Shared/leftTitleWithText';
import Job from './Shared/Job';
import centeredImage from './Shared/centeredImage';
import pricingSection from './Shared/pricing/pricingCardSection';
import pricingTable from './Shared/pricing/pricingTable';
import addOnsPricingCards from './Shared/pricing/addOnsPricingCards';
import faqSection from './Shared/faqSection';
import canaryCards from './Shared/downloads-canary/canaryCards';
import blogPostCardsDynamic from './Shared/blogPostCardsDynamic';
import blogPostCardsStatic from './Shared/blogPostCardsStatic';
import table from './Shared/table';
import sideBar from './Shared/sidebars/sideBar';
import heroWithModalAndButton from './Shared/heroes/heroWithModalAndButton';
import webinarRecapHero from './Shared/pages/webinars/webinarRecapHero';
import stickySideBar from './Shared/sidebars/stickySideBar';
import headerRow from './Shared/texts/headerRow';
import stickyModalNav from './Shared/navs-mobile/sticky-modal-nav/stickyModalNav';
import organizationSchema from '../utils/organizationSchema';
import localBusinessSchema from '../utils/localBusinessSchema';
import cardBasicGrid from './Shared/v5_cards/cardBasicGrid';
import caseStudyThreeAcrossV6 from './Shared/case-studies-new/pages/caseStudyThreeAcrossV6';
/* eslint-disable import/no-cycle */
import cardGridFilterByDate from './Shared/v5_cards/cardGridFilterByDate';
import eventsHero from './Shared/heroes/eventsHero';
import logoWallSectionV6 from './Shared/cta/logoWallSectionV6';
import floatingHeaderSectionV6 from './Shared/floatingHeaderSectionV6';
import listRichV6 from './Shared/listRichV6';
import sectionCtaNumberedV6 from './Shared/sectionCtaNumberedV6';
import splitVideoSection from './Shared/splitVideoSection';
import HeroStackedVideo from './Shared/HeroStackedVideo';
import sideBySideFormV6 from './Shared/sideBySideFormV6';
import AnnouncementSection from './Shared/v6_announcement/AnnouncementSection';
import caseStudySectionV6 from './Shared/caseStudySectionV6';
import sectionQuote from './Shared/sectionQuote';
import cardBasicBlogPost from './Shared/v5_cards/cardBasicBlogPost';
import sideBySideMediaTextV6 from './Shared/sideBySideMediaTextV6';
import stickyBar from './Shared/stickyBar';
import ExampleForm from './Shared/forms/layout/ExampleForm';
import SliderV6 from './Shared/v6_sliders/SliderV6';
import SignupInputBox from './Shared/SignupInputBox';
import eventDynamic from './Shared/eventDynamic';
import MonthAnnualToggle from './Shared/MonthAnnualToggle';
import cardIconChecklistSection from './Shared/pricing/cardIconChecklistSection';
import SideXSidePricing from './Shared/pricing/SideXSidePricing';
import LeftNav from './Shared/sidebars/LeftNav';
import SideBySideLottie from './Shared/SideBySideLottie';
import generateVideoSchema from '../utils/generateVideoSchema';
import chart2023SideBySide from './Shared/charts/chart2023SideBySide';
import PostconHero from './Shared/PostconHero';
import PostconSideBySide from './Shared/PostconSideBySide';
import PreFooterSideBySideLottie from './Shared/PreFooterSideBySideLottie';
import PostconFooter from './Shared/PostconFooter';
import PostconCallOut from './Shared/PostconCallOut';
import PostconCards from './Shared/PostconCards';
import pixelScript from '../utils/pixelScript';
import PostconNavBar from './PostconNavBar';
import sideBySideFormHero from './Shared/sideBySideFormHero';
import PricingTabsSection from './Shared/pricing/pricingTabsSection';
import PricingAddonsTable from './Shared/pricing/pricingAddOnsTable';
import TabsSection from './Shared/tabs/tabsSection';
import CalloutDark from './Shared/cta/CalloutDark';
import LogoWallSideBySide from './Shared/cta/LogoWallSideBySide';
import SideBySideTabs from './Shared/sideBySideTabs';
import TopProductNavBar from './TopProductNavBar';
import LaunchPadCTA from './Shared/cta/LaunchPadCTA';
import HeroPaidMedia from './Shared/heroes/HeroPaidMedia';
import PaidMediaPixels from '../utils/PaidMediaPixels';
import VideoWistiaComponent from './Shared/VideoWistiaComponent';

export default {
  
  TextImageSideXSide,
  Hero,
  HeroStacked,
  BackLinkSection,
  CallOut,
  SideXSide,
  TextSection,
  Feature,
  VideoComponent,
  Divider,
  
  
  hero,
  metricTwo,
  amplitude,
  amplitudeExample,
  eventDynamic,
  footer,
  heroCentered,
  slider,
  downloadsHero,
  leftTitleWithText,
  Job,
  centeredImage,
  pricingSection,
  pricingTable,
  addOnsPricingCards,
  faqSection,
  canaryCards,
  blogPostCardsDynamic,
  blogPostCardsStatic,
  table,
  sideBar,
  heroWithModalAndButton,
  webinarRecapHero,
  stickySideBar,
  headerRow,
  stickyModalNav,
  organizationSchema,
  cardBasicGrid,
  localBusinessSchema,
  caseStudyThreeAcrossV6,
  cardGridFilterByDate,
  eventsHero,
  logoWallSectionV6,
  floatingHeaderSectionV6,
  listRichV6,
  sectionCtaNumberedV6,
  splitVideoSection,
  HeroStackedVideo,
  sideBySideFormV6,
  AnnouncementSection,
  caseStudySectionV6,
  sectionQuote,
  cardBasicBlogPost,
  sideBySideMediaTextV6,
  stickyBar,
  ExampleForm,
  SliderV6,
  SignupInputBox,
  LeftNav,
  MonthAnnualToggle,
  cardIconChecklistSection,
  SideXSidePricing,
  SideBySideLottie,
  generateVideoSchema,
  chart2023SideBySide,
  PostconHero,
  PostconSideBySide,
  PreFooterSideBySideLottie,
  PostconFooter,
  PostconCallOut,
  PostconCards,
  pixelScript,
  PostconNavBar,
  sideBySideFormHero,
  PricingTabsSection,
  PricingAddonsTable,
  TabsSection,
  CalloutDark,
  LogoWallSideBySide,
  SideBySideTabs,
  TopProductNavBar,
  LaunchPadCTA,
  HeroPaidMedia,
  PaidMediaPixels,
  VideoWistiaComponent
};
